var _path, _path2, _path3, _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutoinvestEnabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9975 4.72852V10.1831H16.543",
    stroke: "#04102A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.2749V13.8203H7.45454",
    stroke: "#04102A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28182 9.27466C4.74288 7.97174 5.52648 6.80684 6.55951 5.88868C7.59255 4.97051 8.84133 4.32899 10.1894 4.02399C11.5374 3.71898 12.9407 3.76043 14.2684 4.14445C15.596 4.52848 16.8048 5.24258 17.7818 6.22011L22 10.1838M2 13.8201L6.21818 17.7838C7.19522 18.7613 8.40398 19.4754 9.73164 19.8594C11.0593 20.2434 12.4626 20.2849 13.8106 19.9799C15.1587 19.6749 16.4075 19.0334 17.4405 18.1152C18.4735 17.197 19.2571 16.0321 19.7182 14.7292",
    stroke: "#04102A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#41CE99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.9545L17.875 21L22 16.5",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoinvestEnabled);
export default __webpack_public_path__ + "static/media/autoinvest-enabled.026006c2.svg";
export { ForwardRef as ReactComponent };